module.exports = __webpack_public_path__ + "static/6-2d00f1fe709b0762d49391dcf5b7406c.jpg";